<template>
  <section>
    <div class="content_bg">
      <div class="circle">
        <svg
          width="662px"
          height="662px"
          viewBox="0 0 662 662"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="html"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="reference"
              transform="translate(-1009.5, 115)"
              fill="#94D6BE"
            >
              <g id="Section_01" transform="translate(0, 90)">
                <path
                  d="M1340.5,457 C1523.30625,457 1671.5,308.806252 1671.5,126 C1671.5,-56.8062522 1523.30625,-205 1340.5,-205 C1157.69375,-205 1009.5,-56.8062522 1009.5,126 C1009.5,308.806252 1157.69375,457 1340.5,457 Z"
                  id="Ellipse-1"
                ></path>
              </g>
            </g>
          </g>
        </svg>
      </div>

      <div class="content">
        <div>
          <div class="welcome_text1">레퍼런스</div>
          <div class="welcome_text2">
            고객사의 서비스는<br />
            곧 먼데이리스의 얼굴입니다.
          </div>
        </div>

        <div>
          <img
            class="welcome_box"
            src="@/assets/images/reference_main_image.png"
          />
        </div>
      </div>
    </div>
  </section>
</template>
  
  <script>
import Caption from "./Caption.vue";
export default {
  components: {
    Caption,
  },
  data() {
    return {};
  },
};
</script>
  
<style scoped>
.content_bg {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 400px;
  background-color: #e47786;
  position: relative;
  overflow: hidden;
}

.circle {
  position: absolute;
  top: -200px;
  right: -150px;
}

.content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100vw;
  height: 100%;
  max-width: 1140px;
  padding: 0 20px 0px 20px;
  z-index: 1;
  /* background-color: #f00; */
}

.welcome_box {
  width: 348px;
}

.welcome_text1 {
  font-weight: 700;
  font-size: 40px;
  color: #ffffff;
  letter-spacing: -1px;
  margin-bottom: 0.5em;
}

.welcome_text2 {
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 35px;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    display: block;
    justify-content: center;
    width: 100vw;
    height: fit-content;
    background-color: #e47786;
    position: relative;
    overflow: hidden;
  }

  .circle {
    position: absolute;
    top: 450px;
    left: -30px;
    z-index: 0;
  }

  .content {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: 100%;
    max-width: 1140px;
    padding: 80px 20px 120px 20px;
    z-index: 100;
    /* background-color: #f00; */
  }

  .welcome_box {
    margin-top: 40px;
    width: 253px;
    z-index: 99;
  }

  .welcome_text1 {
    font-weight: 700;
    font-size: 32px;
    color: #ffffff;
    letter-spacing: -1px;
    margin-bottom: 0.5em;
  }

  .welcome_text2 {
    font-size: 20px;
    color: #ffffff;
    letter-spacing: 0;
    line-height: 25px;
  }
}
</style>
  